'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _constants = require('../constants');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.SET_VALUE:
      {
        return Object.assign({}, state, _defineProperty({}, action.name, action.value));
      }
    case _constants.actionTypes.SET_VALUES:
      {
        return Object.assign({}, state, action.values);
      }
    case _constants.actionTypes.RESET_FIELDS:
      {
        return Object.assign({}, state, action.fields.reduce(function (acc, curr) {
          return Object.assign({}, acc, _defineProperty({}, curr, undefined));
        }, {}));
      }
    default:
      return state;
  }
};